module.exports = __webpack_public_path__ + "img/Ru-studio.bcbfcb39.gif";